import * as go from 'gojs';
import theme from 'theme/theme';

const $ = go.GraphObject.make;

const options = () => ({
  stroke: theme.palette.grey[800],
  spacingBelow: 2,
  spacingAbove: 2,
  alignment: go.Spot.Left,
});

const font = (_weight: 400 | 500) =>
  new go.Binding('font', '', (node, data) => {
    const canvasBodyFontSize = data.part.data.canvasBodyFontSize.size;
    return `normal normal 500 ${canvasBodyFontSize}px Sandvik Sans Text`;
  });

const titleColumn = (col: number, margin = 4) =>
  $(
    go.TextBlock,
    {
      ...options(),
      margin: new go.Margin(0, margin, 0, 0),
      column: col,
    },
    new go.Binding('visible', '', (node) => {
      return typeof node.titles[`col${col + 1}`] !== 'undefined';
    }),
    new go.Binding('text', '', (node) => {
      return node.titles[`col${col + 1}`];
    }),
    font(500),
  );

const column = (col: number) =>
  $(
    go.TextBlock,
    {
      ...options(),
      column: col,
    },
    new go.Binding('visible', '', (node) => {
      return typeof node[`col${col + 1}`] !== 'undefined';
    }),
    new go.Binding('text', '', (node) => {
      return node[`col${col + 1}`];
    }),
    font(400),
  );

/**
 * Template for displaying flow properties tables
 */
export const TableRowPanel = $(
  go.Panel,
  'Table',
  {
    defaultRowSeparatorStroke: 'transparent',
    defaultColumnSeparatorStroke: 'transparent',
  },
  $(
    go.Panel,
    'TableRow',
    { isPanelMain: true },
    titleColumn(0, 24),
    titleColumn(1),
    titleColumn(2),
    titleColumn(3),
    titleColumn(4),
    titleColumn(5),
    titleColumn(6, 0),
  ),
  new go.Binding('itemArray', '', (node) => node.data),
  {
    itemTemplate: $(
      go.Panel,
      'TableRow',
      column(0),
      column(1),
      column(2),
      column(3),
      column(4),
      column(5),
      column(6),
    ),
  },
);
